import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/db53428op8h4ruqk277g';

const CHANNEL_OPTIONS = ['全部爆料', '明星绯闻', '网红黑料', '吃瓜现场', '演出动态'];

type Status = 'idle' | 'submitting' | 'success' | 'error';

export default function Newsletter() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (status === 'submitting') return;

    const form = event.currentTarget;
    const formData = new FormData(form);

    // Honeypot check before sending anything
    const honeypot = String(formData.get('company_alt') || '').trim();
    if (honeypot !== '') {
      setStatus('success');
      setSuccessMsg('订阅成功，我们会在下一次爆料盘点时通知你。');
      return;
    }

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'company_alt') return;
      params.append(key, String(value));
    });

    setStatus('submitting');
    setFormError('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || '';

      const isSpam = String(serverMsg).toLowerCase().includes('spam');
      const isOk = response.ok && parsed?.code === 'OK';

      if (isOk && !isSpam) {
        setStatus('success');
        setSuccessMsg('订阅成功，我们会在下一次爆料盘点时通知你。');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，提交失败，请稍后重试。');
    }
  };

  return (
    <section id="subscribe" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-50">
      <div className="rounded-lg overflow-hidden bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-900">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 md:p-10 lg:p-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold text-primary-100 bg-white/10 px-3 py-1.5 rounded-full mb-4">
              <i className="ri-mail-send-line"></i> 订阅爆料
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50 leading-snug mb-3">
              明天的新爆料，第一时间通知你
            </h2>
            <p className="text-sm md:text-base text-background-100 leading-relaxed mb-5">
              每天一次爆料盘点，只发当天真正值得看的内容。订阅仅用于发送提醒，支持随时退订。
            </p>
            <ul className="space-y-2.5">
              {['每日热点集中整理，不用来回刷', '标注已知信息与待核实部分', '只需邮箱，不收集多余信息'].map((text, i) => (
                <li key={text} className="flex items-center gap-3 text-sm text-background-100">
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full ${i === 1 ? 'bg-accent-500 text-background-900' : 'bg-white/15 text-background-50'}`}>
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {text}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-50 rounded-lg p-5 md:p-6">
            {status === 'success' ? (
              <div className="flex flex-col items-center justify-center text-center py-8">
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-checkbox-circle-line text-3xl"></i>
                </span>
                <p className="font-heading font-bold text-foreground-950 mb-1">订阅已提交</p>
                <p className="text-sm text-foreground-600">{successMsg}</p>
              </div>
            ) : (
              <form id="baoliao-subscribe-form" data-readdy-form onSubmit={handleSubmit} noValidate>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">留下邮箱，订阅每日爆料</h3>

                <div className="mb-4">
                  <label htmlFor="subscribe-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱地址 <span className="text-primary-600">*</span>
                  </label>
                  <div className="relative">
                    <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
                    <input
                      id="subscribe-email"
                      type="email"
                      name="email"
                      required
                      autoComplete="email"
                      placeholder="you@example.com"
                      className="w-full pl-10 pr-3 py-2.5 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="subscribe-channel" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    想优先关注的频道
                  </label>
                  <select
                    id="subscribe-channel"
                    name="channel"
                    defaultValue="全部爆料"
                    className="w-full px-3 py-2.5 text-sm rounded-md bg-background-50 border border-background-200 text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400"
                  >
                    {CHANNEL_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="company_alt">
                  <label htmlFor="company_alt">Company</label>
                  <input
                    id="company_alt"
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>

                {status === 'error' && (
                  <p className="mb-4 flex items-start gap-2 text-sm text-primary-700 bg-primary-50 border border-primary-200 rounded-md px-3 py-2">
                    <i className="ri-error-warning-line mt-0.5"></i>
                    <span>{formError}</span>
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === 'submitting'}
                  className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {status === 'submitting' ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      提交中…
                    </>
                  ) : (
                    <>
                      <i className="ri-notification-3-line"></i>
                      立即订阅
                    </>
                  )}
                </button>
                <p className="mt-3 text-xs text-foreground-500 text-center">
                  点击订阅即表示你同意我们使用该邮箱发送爆料盘点内容。
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}